"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.feeStructure = void 0;
const paypal_public_1 = require("@joindeed/paypal-public");
const enums_1 = require("../types/enums");
const utils_1 = require("../utils");
const calculateStripeFees_1 = require("./calculateStripeFees");
const simpleProviderFees = {
    [enums_1.DonationProvider.NFG]: { relative: 5, fixed: 0 },
    [enums_1.DonationProvider.GlobalGiving]: { relative: 5, fixed: 0 },
    [enums_1.DonationProvider.GiveIndia]: { relative: 7.5, fixed: 0 },
};
const paypalFeeStructure = (params) => {
    const payPalFees = (0, paypal_public_1.modelFeeStructureForCountry)(params);
    return {
        relative: payPalFees.relativeFee,
        fixed: payPalFees.fixedFee,
    };
};
const cafFeeStructure = (params) => {
    // TODO NOTE-ZR: this seems like it's not gonna be used anywhere
    const CAF_PPGF_COUNTRY_CODE = 'US';
    const cafFees = (0, paypal_public_1.modelFeeStructureForCountry)({ ...params, countryCode: CAF_PPGF_COUNTRY_CODE, isCAFDonation: true });
    return {
        relative: cafFees.relativeFee,
        fixed: cafFees.fixedFee,
    };
};
const feeStructure = (params) => {
    const { donationProvider } = params;
    switch (donationProvider) {
        case enums_1.DonationProvider.NFG:
        case enums_1.DonationProvider.GiveIndia:
        case enums_1.DonationProvider.GlobalGiving:
            return simpleProviderFees[donationProvider];
        case enums_1.DonationProvider.Stripe:
            return (0, calculateStripeFees_1.stripeFeeStructure)(params);
        case enums_1.DonationProvider.PayPal:
            return paypalFeeStructure(params);
        case enums_1.DonationProvider.CAF:
            return cafFeeStructure(params);
        case enums_1.DonationProvider.Give2Asia:
            return (0, calculateStripeFees_1.stripeFeeStructure)(params);
        default:
            // isNever() is used here to exhaustively check we handled every case of the DonationProvider enum
            (0, utils_1.isNever)(donationProvider);
            throw new Error(`Donation provider ${donationProvider} is not supported for fees calculation`);
    }
};
exports.feeStructure = feeStructure;
//# sourceMappingURL=feeStructure.js.map